import React, { useMemo } from "react";
import PropTypes from "prop-types";
import Select from "react-select";

const MultiSelectDropdown = (props) => {
  const dropdownStyles = {
    container: (styles) => ({
      ...styles,
      zIndex: 2,
      width: "100%",
    }),
    control: (styles, { isDisabled, isFocused }) => ({
      ...styles,
      backgroundColor: isDisabled ? "#D2D6DB80" : "white",
      paddingLeft: "0.3rem",
      borderRadius: "0.375rem",
      borderColor: isFocused ? "#8b58f1" : "#CBCAD7",
      boxShadow: isFocused ? "0 0 0 1px #8b58f1" : undefined,
      ":hover": {
        borderColor: "#8b58f1",
      },
    }),
    option: (styles, { isDisabled, isSelected, isFocused }) => {
      return {
        ...styles,
        fontSize: "0.875rem",
        backgroundColor: isDisabled
          ? undefined
          : isSelected
          ? "#8b58f1"
          : isFocused
          ? "#8b58f11a"
          : undefined,
        ":active": {
          ...styles[":active"],
          backgroundColor: "#8b58f11a",
        },
      };
    },
    input: (styles) => ({
      ...styles,
      height: "35px",
    }),
    placeholder: (styles) => ({
      ...styles,
      fontSize: "0.875rem",
    }),
    singleValue: (styles, { data }) => ({
      ...styles,
      fontSize: "0.875rem",
    }),
    indicatorSeparator: (styles) => ({
      ...styles,
      display: "none",
    }),
    indicatorsContainer: (styles) => ({
      ...styles,
      paddingRight: "0.3rem",
    }),
    dropdownIndicator: (styles) => ({
      ...styles,
      "& svg": {
        color: "#6C737F",
      },
    }),
    menu: (styles) => ({
      ...styles,
      zIndex: 999,
    }),
    menuPortal: (styles) => ({
      ...styles,
      zIndex: 9999,
    }),
    multiValue: (styles, { data }) => {
      return {
        ...styles,
        backgroundColor: "#8b58f1",
        borderRadius: "1rem",
        paddingLeft: "0.5rem",
        paddingRight: "0.5rem",
      };
    },
    multiValueLabel: (styles, { data }) => ({
      ...styles,
      color: "#fff",
    }),
    multiValueRemove: (styles, { data }) => ({
      ...styles,
      color: "#111",
      backgroundColor: "#8b58f1",
      svg: {
        backgroundColor: "#fff",
        borderRadius: "1rem",
        ":hover": {
          backgroundColor: "red",
          color: "#fff",
        },
      },
      ":hover": {
        backgroundColor: "#8b58f1",
      },
    }),
  };

  const selectedValue = useMemo(() => {
    if (Array.isArray(props?.selectedValue) && Array.isArray(props?.options)) {
      const _selectedValues = props?.options?.filter((option) =>
        props?.selectedValue?.includes(option?.value)
      );
      return _selectedValues;
    }
    return [];
  }, [props?.options, props?.selectedValue]);

  const allOption = {
    label:
      selectedValue.length === props?.options.length
        ? "Unselect all"
        : "Select all",
    value: "*",
  };

  const onChangeItem = (selected, event) => {
    if (selected !== null && selected.length > 0) {
      if (selected[selected.length - 1].value === allOption.value) {
        if (selected?.length == props.options?.length + 1) {
          return props.onChange([]);
        }
        return props.onChange([...props.options]);
      }
      let result = [];
      if (selected.length === props.options.length) {
        if (selected.includes(allOption)) {
          result = selected.filter(
            (option) => option.value !== allOption.value
          );
        } else if (event.action === "select-option") {
          result = [...props.options];
        }
        return props.onChange(result);
      }
    }

    return props.onChange(selected);
  };

  return (
    <Select
      styles={dropdownStyles}
      classNamePrefix="react-select"
      placeholder="-Select-"
      value={selectedValue}
      name={props.selectedName}
      isMulti
      isClearable={false}
      components={{
        MultiValueRemove: (props) => (
          <div {...props.innerProps}>
            <svg
              width="13"
              height="13"
              viewBox="0 0 13 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.4987 12.1654C9.62831 12.1654 12.1654 9.62831 12.1654 6.4987C12.1654 3.36908 9.62831 0.832031 6.4987 0.832031C3.36908 0.832031 0.832031 3.36908 0.832031 6.4987C0.832031 9.62831 3.36908 12.1654 6.4987 12.1654Z"
                fill="white"
              />
              <path
                d="M7.91536 5.08203L5.08203 7.91536M5.08203 5.08203L7.91536 7.91536"
                stroke="#333333"
                stroke-width="0.6"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        ),
      }}
      {...props}
      menuPlacement="auto"
      options={
        Array.isArray(props.options) && props.options?.length
          ? [allOption, ...props.options]
          : []
      }
      onChange={onChangeItem}
    />
  );
};

MultiSelectDropdown.propTypes = {
  options: PropTypes.array,
  value: PropTypes.any,
  onChange: PropTypes.func,
  allowSelectAll: PropTypes.bool,
};

export default MultiSelectDropdown;
